// extracted by mini-css-extract-plugin
export default {"productPage":"Keranjang_productPage__UOjMW","titleGroup":"Keranjang_titleGroup__SW+Xn","container":"Keranjang_container__-1llZ","emptyCart":"Keranjang_emptyCart__ZKM6S"};